export default "__VITE_ASSET__CPOpJqV9__"